module.exports = __webpack_public_path__ + "img/logo_bfc.12a64df8.png";